<script>
export default {
    props: {
        label: {
            type: String,
            required: true,
        },
        value: {
            type: Array,
            default: null
        },
        defaultValue: {
            type: [Number, String],
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        disabledValue: {
            type: String,
            default: 'N/A'
        },
        translationPrefix: {
            type: String,
            default: undefined
        }
    },
    data () {
        return {
            toggled: false,
            event: undefined
        }
    },
    computed: {
        valueClasses: {
            get() {
                const classPrefix = 'dropdown-menu-multi-select__value';
                const length = this.value.length;
                if (length < 3) {
                    return classPrefix;
                } else if (length >= 3 && length < 5) {
                    return classPrefix + '-small'
                } else if (length >= 5 && length < 10){
                    return classPrefix + '-smaller'
                } else {
                    return classPrefix + '-smallest'
                }
            }
        }
    },
    methods: {
        toggle () {
            if (!this.disabled) {
                if (!this.toggled) {
                    document.addEventListener('click', this.clickEvent);
                } else {
                    document.removeEventListener('click', this.clickEvent);
                }
                this.toggled = !this.toggled;
            }
        },
        click (val) {
            if (this.value.indexOf(val) === -1) {
                this.$emit('select', val);
            } else {
                this.$emit('deselect', val);
            }
        },
        reset () {
            this.$emit('reset');
        },
        clickEvent (event) {
            if (!event.target.classList.contains('dropdown-menu-multi-select__button')) {
                this.toggle();
            }
        }
    }
}
</script>
<template>
    <div :class="{'dropdown-menu-multi-select--disabled': disabled}"
         class="dropdown-menu-multi-select"
         @click="toggle()">
        <div class="dropdown-menu-multi-select__button">
            <div class="dropdown-menu-multi-select__label">
                {{ label }}:
            </div>
            <div v-if="value.length === 1" :class="valueClasses">
                <span>{{ translationPrefix ? $t(translationPrefix + '.' + value) : value }}</span>
            </div>
            <div v-if="value.length > 1" :class="valueClasses">
                <span v-for="(val, index) in value" :key="'dropdown-multi-value__' + index">
                    <span>{{ translationPrefix ? $t(translationPrefix + '.' + val) : val }}</span>
                    <span v-if="index < value.length - 1">, </span>
                </span>
            </div>
        </div>
        <div v-if="toggled" class="dropdown-menu-multi-select__dropdown">
            <div class="dropdown-menu-multi-select__reset" @click="reset">
                {{ translationPrefix ? $t(translationPrefix + '.' + 'reset') : 'Reset' }}
            </div>
            <div v-for="(item, index) in items"
                 :class="{'dropdown-menu-multi-select__choice--selected': value.indexOf(item) !== -1}"
                 :key="'dropdown-multi-choice__' + index"
                 class="dropdown-menu-multi-select__choice"
                 @click="click(item)">
                {{ translationPrefix ? $t(translationPrefix + '.' + item) : item }}
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/DropDownMenuMultiSelect/DropDownMenuMultiSelect.vue